import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

//import localizes from '../Localizes';

import './Button.less';

class Button extends React.Component {
    static displayName = 'Assets.Button';
    static propTypes = {
        id: PropTypes.string,
        active: PropTypes.bool,
        block: PropTypes.bool,
        children: PropTypes.node,
        className: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.object,
            PropTypes.string
        ]),
        disabled: PropTypes.bool,
        flat: PropTypes.bool,
        href: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        onClick: PropTypes.func,
        target: PropTypes.string,
        type: PropTypes.oneOf(['button', 'reset', 'submit'])
    };
    static defaultProps = {
        className: 'btn btn-basic',
        onClick: function() {},
        block: false, // full width button
        flat: false, // flat button used on white background
        disabled: false,
        active: false
    };
    state = {
        href: this.props.href || '#'
    };

    /**
     * @param {Object} props Props
     */
    constructor(props) {
        super(props);
    }

    /**
     * @param {Object} props Props
     */
    componentWillReceiveProps(props) {
        this.props = props;
        this.setState({
            href: props.href || '#'
        });
    }

    /**
     * @returns {XML} Component
     */
    render() {
        let className = this.props.className;

        if (this.props.block) {
            className = classnames(['btn-block', className]);
        }
        if (this.props.flat) {
            className = classnames(['btn--highlighted', className]);
        }
        if (this.props.active) {
            className = classnames(['active', className]);
        }

        let renderFuncName = this.props.href || this.props.target ?
            'renderAnchor' : 'renderButton';

        return this[renderFuncName](className);
    }

    /**
     * @param {String} classes Classes
     * @returns {XML} Component
     */
    renderAnchor(classes) {
        return (
            <a href={this.state.href} className={classes} disabled={this.props.disabled}>
                {this.props.children}
            </a>
        );
    }

    /**
     *
     * @param {String} classes Classes
     * @returns {XML} Component
     */
    renderButton(classes) {
        return (
            <button type={this.props.type || 'button'} className={classes}
                disabled={this.props.disabled}
                onClick={this.props.onClick}
                id={this.props.id}>
                {this.props.children}
            </button>
        );
    }
}
export default Button;



// WEBPACK FOOTER //
// ./src/UserSettings/components/Input/Button/index.jsx